import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Alert, AlertProps } from './alertsTypes';

const syncAlertPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<AlertProps>>();
const alertPayloadCreator = getPayloadCreator<Alert>();
const alertsPayloadCreator = getPayloadCreator<Alert[]>();

export const getAlerts = createAction('GET_ALERTS', getPayloadCreator());
export const getAlertsSuccess = createAction('GET_ALERTS_SUCCESS', syncAlertPayloadCreator);
export const getAlertsFailure = createAction('GET_ALERTS_FAILURE', errorPayloadCreator);

export const updateAlert = createAction('UPDATE_ALERT', alertPayloadCreator);
export const updateAlertSuccess = createAction('UPDATE_ALERT_SUCCESS', alertPayloadCreator);
export const updateAlertFailure = createAction('UPDATE_ALERT_FAILURE', errorPayloadCreator);

export const deleteAlert = createAction('DELETE_ALERT', alertPayloadCreator);
export const deleteAlertSuccess = createAction('DELETE_ALERT_SUCCESS', alertPayloadCreator);
export const deleteAlertFailure = createAction('DELETE_ALERT_FAILURE', errorPayloadCreator);

export const batchAlerts = createAction('BATCH_ALERTS', alertsPayloadCreator);
export const batchAlertsSuccess = createAction('BATCH_ALERTS_SUCCESS', alertsPayloadCreator);
export const batchAlertsFailure = createAction('BATCH_ALERTS_FAILURE', errorPayloadCreator);
